export function preloadImage(url) {
  const img = new Image();
  img.src = url;
}
